import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { NamedLink } from '../../components';

import css from './TabNav.module.css';

function getTabStatus(id, tabsStatus) {
  if (typeof id !== 'string' || !id.includes('_')) return false;
  const key = id.split('_')[1];
  return tabsStatus[key] || false;
}

const Tab = props => {
  const {
    className,
    id,
    disabled,
    text,
    selected,
    linkProps,
    isEditListingTabs,
    tabsStatus,
    style,
  } = props;
  const linkClasses = classNames(css.link, {
    [css.selectedLink]: selected,
    [css.disabled]: disabled,
    [css.completedLink]: getTabStatus(id, tabsStatus),
  });

  return (
    <div id={id} className={className} style={style}>
      <NamedLink className={linkClasses} {...linkProps}>
        <span className={css.tabTxt}> {text}</span>
        {isEditListingTabs && <span className={css.circle}></span>}
      </NamedLink>
    </div>
  );
};

Tab.defaultProps = { className: null, disabled: false, selected: false };

const { arrayOf, bool, node, object, string } = PropTypes;

Tab.propTypes = {
  id: string.isRequired,
  className: string,
  text: node.isRequired,
  disabled: bool,
  selected: bool,
  linkProps: object.isRequired,
};

const TabNav = props => {
  const { className, rootClassName, tabRootClassName, tabs, isEditListingTabs, tabsStatus } = props;
  const classes = classNames(
    rootClassName || css.root,
    className,
    isEditListingTabs ? css.editListingTabs : null
  );
  const tabClasses = tabRootClassName || css.tab;
  return (
    <nav className={classes}>
      {tabs.map((tab, index) => {
        const tabsLength = tabs.length;
        const id = typeof tab.id === 'string' ? tab.id : `${index}`;
        return (
          <Tab
            tabsStatus={tabsStatus}
            isEditListingTabs={isEditListingTabs}
            key={id}
            id={id}
            completedLink={tab}
            className={tabClasses}
            style={{ width: isEditListingTabs ? `calc(100% / ${tabsLength})` : null }}
            {...tab}
          />
        );
      })}
    </nav>
  );
};

TabNav.defaultProps = {
  className: null,
  rootClassName: null,
  tabRootClassName: null,
  tabClassName: null,
};

TabNav.propTypes = {
  className: string,
  rootClassName: string,
  tabRootClassName: string,
  tabs: arrayOf(object).isRequired,
};

export default TabNav;
